module.exports = __webpack_public_path__ + "static/media/mike.b40a2c67.jpg";